import React from 'react'
import { Description, ABV, SRM, Availability, Style, MainImage } from '.'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'

const Highlights: React.FC = () => {
    const { productData } = useBrewDetailStore()
    return (
        <div className=' h-full rounded-lg'>
            <div className='md:p-10 flex flex-col items-center h-full gap-8 px-3 py-2'>
                <div className='flex items-center w-full rounded-lg'>
                    <div className='h-80 rounded-xl lg:w-full relative flex items-center w-full overflow-hidden'>
                        <MainImage />
                    </div>
                </div>
                <div className='xl:py-4 flex flex-col w-full py-2'>
                    <div className='xl:gap-4 flex gap-2'>
                        <div className='gap-y-10 gap-x-2 grid w-full grid-cols-2'>
                            <div className='flex flex-col items-start gap-2'>
                                <Style />
                            </div>
                            <div className='flex justify-end'>
                                <ABV />
                            </div>
                            <SRM />
                            <Availability />
                            <div className='flex flex-col col-span-2 gap-2'>
                                <Description />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Highlights
